/** Broad, subdued highlights keep rotating CAD surfaces readable. */
// Multiplies the worker's existing vertex colors for a slightly darker, cool gray.
export const CAD_PREVIEW_TINT = '#d5d8de';

export const CAD_PREVIEW_MATERIAL = {
  metalness: 0.6,
  roughness: 0.3,
  envMapIntensity: 0.3,
} as const;
